import "./GuidedMeditationContent.scss";

interface GuidedMeditationContentProps {
  videoUrl: string;
  onEnded: () => void;
}

function GuidedMeditationContent({ videoUrl, onEnded }: GuidedMeditationContentProps) {
  return (
    <div className="guided-meditation">
      <div className="guided-meditation__video-wrap">
        <video
          className="guided-meditation__video"
          src={videoUrl}
          controls
          autoPlay
          playsInline
          onEnded={onEnded}
        />
      </div>
    </div>
  );
}

export default GuidedMeditationContent;
